module.exports = __webpack_public_path__ + "static/media/model-pajero-91-lwb.c7356a0b.webp";